import { useLocalization } from '@/data/Localization';

export const useForgotPasswordTitle = ({ step }: { step: number }) => {
	const nls = useLocalization('ForgotPassword');

	const title =
		step === 0
			? nls.Title.t()
			: step === 1
			? nls.VerificationCodeTitle.t()
			: nls.ConfirmationTitle.t();

	return title;
};
